import React from 'react';
import { Text, Flex, Button } from '@upsales/components';
import { useTranslation } from 'Components/Helpers/translate';
import NotetakerStatusChip from 'App/components/NotetakerStatusChip/NotetakerStatusChip';

type NotetakerStatus = { state: string; reason?: string };
type Props = { status?: NotetakerStatus; onInvite: () => void; inviting: boolean };

// A wont_join reason a manual invite can resolve → offer the button. Hard filters / done / ended → no button.
const INVITABLE_REASONS = ['credits_exhausted'];

export default function NotetakerStatusSection({ status, onInvite, inviting }: Props) {
	const { t } = useTranslation();

	if (!status) {
		return null;
	}

	const canInvite =
		status.state === 'failed' ||
		(status.state === 'wont_join' && status.reason != null && INVITABLE_REASONS.includes(status.reason));

	return (
		<Flex className="section notetaker-status-section" direction="column" gap="u2">
			<label>{t('default.aiSummary')}</label>
			<NotetakerStatusChip status={status} />
			{status.reason ? (
				<Text size="sm" color="grey-11">
					{t(`appointment.notetakerReason.${status.reason}`)}
				</Text>
			) : null}
			{canInvite ? (
				<Button size="sm" onClick={onInvite} loading={inviting}>
					{t('appointment.notetakerInvite')}
				</Button>
			) : null}
		</Flex>
	);
}
